export enum NotificationType {
  DEFAULT = 'default',
  SUCCESS = 'success',
  ERROR = 'error',
  INFO = 'info',
  WARNING = 'warning',
  PERMISSIONS_MSG = 'No Permission. Please contact administrator'
 }
